import debug from 'debug'
import {
  BROWSER_STORAGE_AUDIENCE_TRACKING_OPTOUT,
  deleteEntryFromLocalStorage,
  deleteEntryFromSessionStorage,
  getLocalStorageKeys,
  getSessionStorageKeys
} from '../../utils/browserStorageService'

const d = debug('storage')

/**
 * Please keep in mind that the default cookies names can be changed:
 * https://developers.didomi.io/cmp/web-sdk/consent-notice/cookies#cookie-name
 */
export const KEY_TCF_NAME = 'euconsent-v2'
export const KEY_DIDOMI_NAME = 'didomi_token'

const consentKeys = [KEY_DIDOMI_NAME, KEY_TCF_NAME, BROWSER_STORAGE_AUDIENCE_TRACKING_OPTOUT]

const getCandidateLocalStorageKeys = () => getLocalStorageKeys().filter(key => !consentKeys.includes(key))

const getCandidateSessionStorageKeys = () => getSessionStorageKeys().filter(key => !consentKeys.includes(key))

export const cleanStorageAccordingConsent = storageConsent => {
  if (storageConsent) return

  if (d.enabled) {
    d('Existing localStorage keys:', getLocalStorageKeys())
    d('Existing sessionStorage keys:', getSessionStorageKeys())
  }

  getCandidateLocalStorageKeys().forEach(key => deleteEntryFromLocalStorage(key))
  getCandidateSessionStorageKeys().forEach(key => deleteEntryFromSessionStorage(key))

  if (d.enabled) {
    d('Remaining localStorage keys:', getLocalStorageKeys())
    d('Remaining sessionStorage keys:', getSessionStorageKeys())
  }
}
